
export interface IPostPromote {

    id?: number;
    postId?: number;
    postName?: string;
    startDate?: Date;
    endDate?: Date;
    ifPostIsSubProduct?: boolean;
    shopName?: string
}

export class PostPromote implements IPostPromote {
    constructor(
        public id? : number,
        public postId? : number,
        public postName? : string,
        public startDate? : Date,
        public endDate?: Date,
        public ifPostIsSubProduct?: boolean,
        public shopName?: string
    ){
        this.id = id;
        this.postId = postId;
        this.postName = postName;
        this.startDate = startDate;
        this.endDate = endDate;
        this.ifPostIsSubProduct = ifPostIsSubProduct;
        this.shopName = shopName;
    }
}